import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Contact from "@/components/Contact";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieConsent from "@/components/CookieConsent";
import CookiePolicyPage from "@/components/CookiePolicyPage";
import TermsAndConditions from "@/components/TermsAndConditions";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import TrustSignals from "@/components/TrustSignals";
import HomePage from "@/pages/HomePage";
import CorporatePage from "@/pages/CorporatePage";
import NotFoundPage from "@/pages/NotFoundPage";
import VitoPage from "@/pages/VitoPage";
import { VITO } from "@/data/fleet";
import RentalsPage from "@/pages/RentalsPage";
import TransfersPage from "@/pages/TransfersPage";
import ToursPage from "@/pages/ToursPage";
import ContactPage from "@/pages/ContactPage";
import { SEO } from "@/components/SEO";
import "./App.css";
import { translations } from "./mockData";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  const location = useLocation();

  const getInitialLanguage = () => {
    const path = window.location.pathname.toLowerCase();
    if (path.startsWith('/en')) return 'en';
    return 'ro';
  };

  const [language, setLanguage] = useState(getInitialLanguage);
  const t = translations[language];

  useEffect(() => {
    document.documentElement.lang = language === 'en' ? 'en' : 'ro';
  }, [language]);

  // GTM: Push virtual pageview on every SPA route change
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'virtualPageview',
      pagePath: location.pathname + location.search,
      pageTitle: document.title,
    });
  }, [location]);

  const isLegalPage = ['/politica-de-cookie', '/termeni-si-conditii', '/politica-de-confidentialitate', '/cookie-policy'].includes(location.pathname);
  const isHomePage = ['/', '/en'].includes(location.pathname);

  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop />
      <Header t={t} language={language} setLanguage={setLanguage} />

      <Routes>
        <Route path="/" element={<><SEO path="/" language={language} /><HomePage language={language} /></>} />
        <Route path="/en" element={<><SEO path="/" language={language} /><HomePage language={language} /></>} />
        <Route path="/corporate" element={<><SEO path="/corporate" language={language} /><CorporatePage language={language} /></>} />
        <Route path="/en/corporate" element={<><SEO path="/corporate" language={language} /><CorporatePage language={language} /></>} />
        <Route path="/rent-a-car" element={<><SEO path="/rent-a-car" language={language} /><RentalsPage language={language} /></>} />
        <Route path="/en/rent-a-car" element={<><SEO path="/rent-a-car" language={language} /><RentalsPage language={language} /></>} />
        <Route path={VITO.slugRo} element={<><SEO path={VITO.slugRo} language={language} /><VitoPage language={language} /></>} />
        <Route path={VITO.slugEn} element={<><SEO path={VITO.slugRo} language={language} /><VitoPage language={language} /></>} />
        <Route path="/transfers" element={<><SEO path="/transfers" language={language} /><TransfersPage language={language} /></>} />
        <Route path="/en/transfers" element={<><SEO path="/transfers" language={language} /><TransfersPage language={language} /></>} />
        <Route path="/tours" element={<><SEO path="/tours" language={language} /><ToursPage language={language} /></>} />
        <Route path="/en/tours" element={<><SEO path="/tours" language={language} /><ToursPage language={language} /></>} />
        <Route path="/contact" element={<><SEO path="/contact" language={language} /><ContactPage language={language} /></>} />
        <Route path="/en/contact" element={<><SEO path="/contact" language={language} /><ContactPage language={language} /></>} />
        <Route path="/cookie-policy" element={<CookiePolicyPage language={language} />} />
        <Route path="/termeni-si-conditii" element={<><SEO path="/termeni-si-conditii" language={language} /><TermsAndConditions language={language} /></>} />
        <Route path="/politica-de-confidentialitate" element={<><SEO path="/politica-de-confidentialitate" language={language} /><PrivacyPolicy language={language} /></>} />
        <Route path="/politica-de-cookie" element={<><SEO path="/politica-de-cookie" language={language} /><CookiePolicyPage language={language} /></>} />
        <Route path="/en/cookie-policy" element={<CookiePolicyPage language={language} />} />
        <Route path="/en/termeni-si-conditii" element={<><SEO path="/termeni-si-conditii" language={language} /><TermsAndConditions language={language} /></>} />
        <Route path="/en/politica-de-confidentialitate" element={<><SEO path="/politica-de-confidentialitate" language={language} /><PrivacyPolicy language={language} /></>} />
        <Route path="/en/politica-de-cookie" element={<><SEO path="/politica-de-cookie" language={language} /><CookiePolicyPage language={language} /></>} />
        <Route path="*" element={<NotFoundPage language={language} />} />
      </Routes>

      {isHomePage && <Contact t={t} language={language} showForm={true} />}
      <Footer t={t} language={language} />
      <WhatsAppButton />
      <CookieConsent language={language} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
